import iconWinner from "../../../../../assets/images/Mini-Game/icon-winner.png";
import iconWinnerEn from "../../../../../assets/images/Mini-Game/icon-winner-en.png";
import iconWinnerThadingyut from "../../../../../assets/images/Mini-Game/thadingyut-2025-theme/winner-icon.png";
import iconWinnderNewYear from "../../../../../assets/images/Mini-Game/new-year-2025/icon-winner.png";
import styled from "styled-components";
import PopupWinner from "../PopupFooter/PopupWinner";
import { useEffect, useState } from "react";
import PopupRanking from "../PopupFooter/PopupRanking";
import IconRanking from "../IconRanking";
import { useLocation, useNavigate } from "react-router";
import {
  useNewYear2025Theme,
  useThadingyutTheme,
} from "../../../../../helper/const";
import { useTranslation } from 'react-i18next';
// import { IS_EVENT_THADINGYUT_2025_THEME } from "../../../../../helper/const";

export default function ActionComponent() {
  const { i18n } = useTranslation()
  const [isShowPopupHistory, setIsShowPopupHistory] = useState(false);
  const [isShowPopupRanking, setIsShowPopupRanking] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const IS_EVENT_THADINGYUT_2025_THEME = useThadingyutTheme();
  const IS_EVENT_NEW_YEAR_2025_THEME = useNewYear2025Theme();

  useEffect(() => {
    if (location?.state?.isShowPopupRanking) {
      setIsShowPopupRanking(true);
      navigate(location.pathname, { replace: true });
    }
  }, [location.state]);

  const bg_lang_iconWinner = i18n.language === 'en' ? iconWinnerEn : iconWinner

  return (
    <>
      {isShowPopupHistory ? (
        <PopupWinner
          setIsShowPopupHistory={setIsShowPopupHistory}
          isShowPopupHistory={isShowPopupHistory}
        />
      ) : null}
      {isShowPopupRanking ? (
        <PopupRanking
          isOpen={isShowPopupRanking}
          setIsOpen={setIsShowPopupRanking}
        />
      ) : null}
      <Container
        className={`${IS_EVENT_THADINGYUT_2025_THEME ? "thadingyut-theme" : ""
          } ${IS_EVENT_NEW_YEAR_2025_THEME ? "new-year-25-theme" : ""}`}
      >
        {IS_EVENT_THADINGYUT_2025_THEME ? (
          <img
            srcSet={`${iconWinnerThadingyut} 2x`}
            alt=''
            className={`icon-winner__collect scale-hover-item `}
            onClick={() => setIsShowPopupHistory(true)}
          />
        ) : IS_EVENT_NEW_YEAR_2025_THEME ? (
          <img
            srcSet={`${iconWinnderNewYear} 2x`}
            alt=''
            className={`icon-winner__collect scale-hover-item `}
            onClick={() => setIsShowPopupHistory(true)}
          />
        ) : (
          //  <img
          //   src={iconWinner}
          //   alt=''
          //   className={`icon-winner__collect scale-hover-item `}
          //   onClick={() => setIsShowPopupHistory(true)}
          // />
          <img
            src={bg_lang_iconWinner}
            alt=''
            className={`icon-winner__collect scale-hover-item`}
            onClick={() => setIsShowPopupHistory(true)}
          />
        )}
        <div onClick={() => setIsShowPopupRanking(true)}>
          <IconRanking hiddenClose />
        </div>
      </Container>
    </>
  );
}

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  position: relative;
  z-index: 3;

  &.new-year-25-theme {
    .container-icon-event-2025.container-icon-event-2025__minigame {
      .slideshow {
        width: 120px!important;
        height: 86px!important;
        position: relative;
        overflow: visible;
        img {
          object-fit: contain;
        }

        @media (max-width: 567px) {
          width: 100px !important;
          height: 72px !important;
        }
      }
    }

    .icon-winner__collect {
      width: 105px;
      height: auto;

      @media (max-width: 576px) {
        width: 85px;
      }
    }
  }

  .icon-winner__collect {
    width: 126px;
    height: 100px;
    object-fit: contain;
    cursor: pointer;
    transition: scale 0.3s ease-in-out;

    @media (hover: hover) {
      &:hover {
        scale: 105%;
      }
    }
  }

  .container-icon-event-2025.container-icon-event-2025__minigame {
    .slideshow {
      width: 126px !important;
      height: 100px !important;
      position: relative;
      /* overflow: hidden; */
      overflow: visible;
      img {
        object-fit: contain;
      }

    }
  }

  @media (max-width: 768px) {
    .icon-winner__collect {
      width: 110px;
      height: 87px;
    }

    .container-icon-event-2025.container-icon-event-2025__minigame {
      .slideshow {
        width: 110px !important;
        height: 87px !important;
        position: relative;
        overflow: hidden;
      }
    }
  }

  @media (max-width: 576px) {
    .icon-winner__collect {
      width: 90px;
      height: 72px;
    }
    .container-icon-event-2025.container-icon-event-2025__minigame {
      .slideshow {
        width: 90px !important;
        height: 72px !important;
        position: relative;
        overflow: hidden;
      }
    }
    margin: 0 8px;
  }

  &.thadingyut-theme {
    .container-icon-event-2025.container-icon-event-2025__minigame {
      .slideshow {
        width: 120px !important;
        height: 120px !important;
        position: relative;
        top: -5px;
        overflow: hidden;
      }
    }
    .icon-winner__collect {
      position: relative;
      top: -15px;
    }

    @media (max-width: 768px) {
      .container-icon-event-2025.container-icon-event-2025__minigame {
        .slideshow {
          width: 110px !important;
          height: 110px !important;
          position: relative;
          top: -6px;
          overflow: hidden;
        }
      }
    }

    @media (max-width: 576px) {
      .icon-winner__collect {
        width: 80px;
        height: auto;
      }

      .container-icon-event-2025.container-icon-event-2025__minigame {
        .slideshow {
          width: 100px !important;
          height: 100px !important;
          position: relative;
          overflow: hidden;
        }
      }
    }
  }
`;
